import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ColumnCustomizationModal from "./ColumnCustomizationModal";

const ColumnCustomizationButton = ({
  collections,
  columns,
  activeCollectionId,
  selectedColumnKeys,
  onApply,
  onSave,
  onSaveAs,
  onRenameView,
  onDeleteView,
  saving = false,
  title,
  tooltip = "Customize columns",
  sx = {},
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={tooltip} arrow>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            height: 36,
            width: 36,
            border: "1px solid",
            borderColor: "grey.400",
            borderRadius: 1,
            color: "#333333",
            "&:hover": {
              borderColor: "grey.700",
              backgroundColor: "grey.50",
            },
            ...sx,
          }}
        >
          <TuneOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <ColumnCustomizationModal
        open={open}
        onClose={() => setOpen(false)}
        collections={collections}
        columns={columns}
        activeCollectionId={activeCollectionId}
        selectedColumnKeys={selectedColumnKeys}
        onApply={onApply}
        onSave={onSave}
        onSaveAs={onSaveAs}
        onRenameView={onRenameView}
        onDeleteView={onDeleteView}
        saving={saving}
        title={title}
      />
    </>
  );
};

export default ColumnCustomizationButton;
